import { Link } from "react-router-dom";
import { Library } from "lucide-react";

export const StyleRefsStrip = ({ refs = [] }) => {
  if (!refs.length) return null;
  return (
    <div data-testid="style-refs-strip" className="flex flex-wrap items-center gap-3 rounded-3xl border border-border bg-card/60 p-3 mt-6">
      <span className="flex items-center gap-2 text-xs font-mono2 uppercase tracking-widest text-muted-foreground">
        <Library className="h-4 w-4" /> Styled after your ducks
      </span>
      <ul className="flex flex-wrap gap-2 min-w-0 w-full" aria-label="Selected style references">
        {refs.map((r) => (
          <li key={r.id} data-testid={`style-ref-${r.id}`} className="flex min-w-0 max-w-full items-center gap-2 rounded-2xl border border-border bg-background pl-1 pr-3 py-1 text-xs">
            <img src={r.thumb_small} alt={r.name} className="h-7 w-7 rounded-full object-cover" />
            <span data-testid={`style-ref-name-${r.id}`} className="font-semibold break-words min-w-0" style={{ overflowWrap: "anywhere" }}>{r.name}</span>
          </li>
        ))}
      </ul>
      <Link to="/library" className="text-xs text-accent font-semibold ml-auto hover:underline" data-testid="style-refs-library-link">Manage library →</Link>
    </div>
  );
};
